import type { QuestionnaireItem } from '@medplum/fhirtypes'
import type { ExtendedQuestionnaireResponse } from '@seen/core/models/questionnaireResponse'
import { cn, Label } from '@seen/ui'
import type { JSX } from 'react'
import { match } from 'ts-pattern'
import { getAnswerOptions } from '#src/components/core/combobox/util.ts'
import { RichText } from '#src/components/RichText.tsx'

export function QuestionnaireItemDisplay({
  item,
  questionnaireResponse,
  label,
  className,
}: {
  item: QuestionnaireItem
  questionnaireResponse: ExtendedQuestionnaireResponse | null
  label?: string
  className?: string
}): JSX.Element {
  const value = match(item.type)
    .with(
      'text',
      'string',
      () =>
        (questionnaireResponse?.getAnswerValue(item.linkId) ?? '---') as string
    )
    .with('choice', () => {
      const v = questionnaireResponse?.getAnswerValue(item.linkId)
      const label =
        getAnswerOptions(item).find((option) => option.value === v)?.label ??
        '---'
      return label
    })
    .with('boolean', () => {
      const v = questionnaireResponse?.getAnswerValue(item.linkId) as
        | boolean
        | undefined
      if (v === true) {
        return 'Yes'
      } else if (v === false) {
        return 'No'
      } else {
        return '---'
      }
    })
    .otherwise(() => 'Not implemented') // TODO: handle other types

  return (
    <div className={cn('flex flex-col text-sm', className)}>
      {!!label && <Label className={cn('pb-3')}>{label}</Label>}
      <RichText className={cn({ 'pt-0': !!label })} value={value} />
    </div>
  )
}
